import 'jquery-lazy';

import cart from './_cart';

/**
 * Init tooltips
 */
$('[data-toggle="tooltip"]').tooltip();

/**
 * Init lazy loaded images
 */
$('img.lazy').Lazy();

/**
 * Filter items
 */
function filterItems({
    newPageNo,
    newPageLength,
    newOrderBy,
}) {

    $('#spinner').show();

    const filters = $('#filters input:checked').map((i, el) => `${$(el).data('attribid')}:${$(el).data('attribval').replace(',', '')}${$(el).data('parentval') ? `:${$(el).data('parentval').replace(',', '')}` : ''}`).toArray().join(',');

    const params = $.extend({}, {
        orderby: newOrderBy || $('.orderby').eq(0).val() || undefined,
        limit: newPageLength || $('.pagelength').eq(0).val() || undefined,
        page: newPageNo || undefined,
        s: $('#search').val() || undefined,
        filters,
    });

    location.search = $.param(params);
}

/**
 * Update filters on checkbox click
 */
$('#filters input').on('change', filterItems);

/**
 * Change order by
 */
$('.orderby').on('change', function () {
    filterItems({
        newOrderBy: $(this).val(),
    });
});

/**
 * Change page length
 */
$('.pagelength').on('change', function () {
    filterItems({
        newPageLength: $(this).val(),
    });
});

/**
 * Pagination click
 */
$('.pagination-control').on('click', function () {
    const currentPage = parseInt($(this).parents('.pagination-container').data('currentpage'));
    const newPage = $(this).data('page') === 'next' ? currentPage + 1 : currentPage - 1;
    filterItems({
        newPageNo: newPage,
    });
});

/**
 * Remove value from applied filters
 */
$('#filters .remove-filter').on('click', function (e) {
    e.preventDefault();
    const attribID = $(this).data('attribid');
    const attribval = $(this).data('attribval');
    // If no attribID, must be a search term
    if (!attribID) {
        $('#search').val('');
    } else {
        // Uncheck the corresponding box to remove the filter
        $(`#filters input[data-attribid="${attribID}"][data-attribval="${attribval}"]`).prop('checked', false);
    }
    filterItems({});
});

/**
 * Reset filters button
 */
$('#reloadFilters').on('click', function () {
    $('#spinner').show();
    location.search = '';
});

/**
 * Add to cart
 */
$('.add-to-cart').on('click', function () {
    const itemid = $(this).data('itemid');
    const btnHtml = $(this).html();
    const btnWidth = $(this).width();
    $(this)
        .prop('disabled', true)
        .attr('aria-disabled', true)
        .width(btnWidth)
        .html('<i class="fas fa-spinner fa-pulse fa-fw"></i>');
    cart.add(itemid)
        .then(() => {
            $(this)
                .html(btnHtml)
                .prop('disabled', false)
                .attr('aria-disabled', false);
        });
});
